export default "__VITE_ASSET__805d14f1__"